import React from 'react';
// ANTD
import TextInput from 'components/inputs/TextInput';

const SignatureForm = ({ signatureType, onChange, userFullName }) => (
  <div style={{ margin: 30 }}>
    <h3>Type your legal name to complete signature:</h3>
    <div style={{ marginTop: 20, marginBottom: 20 }}>
      <TextInput
        onChange={value => {
          onChange({
            [`${signatureType}Signature`]: value,
          });
        }}
        placeholder={userFullName}
        style={{
          borderRadius: 0,
          border: 0,
          fontSize: 20,
          borderBottom: '1px dashed #ddd',
          width: '100%',
        }}
      />
    </div>
    <p style={{ fontSize: 10, color: '#999' }}>
      I, <strong>{userFullName}</strong> ({userFullName}
      ), certify that I have read the contract, and understand that clicking 'CONFIRM SIGNATURE' constitutes a legally
      binding signature.
    </p>
  </div>
);

export default SignatureForm;



// WEBPACK FOOTER //
// ./src/routes/contract-sign/ContractPDF/SignatureModal/SignatureForm/index.js